import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiTable } from "../../../components/common/UiTable";

export const AccountHistory = (props) => {
    const TableHeaders = [
        { id: 1, th: 'Date' },
        { id: 2, th: 'Transaction Ref' },
        { id: 3, th: 'Points In' },
        { id: 4, th: 'Points Out' },
        { id: 5, th: 'Points Balance' },
    ];
    return (
        <>
            <UiCardTitle title="Account History" />
            <div className="sb-table-wrapper-bordered">
                <UiTable tableHeader={TableHeaders} className="sb-bordered-table-templ">
                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  - 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  - 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  - 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  - 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  - 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  - 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  - 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                    <tr>
                        <td className="sb-bordered-table-templ__date">
                            <div> Thurs 26th Jan 2023 </div>
                        </td>
                        <td className="sb-bordered-table-templ__ref">
                            <div> Lorem Epsum 123 </div>
                        </td>
                        <td className="sb-bordered-table-templ__points">
                            <div> + 50 Points </div>
                        </td>
                        <td className="sb-bordered-table-templ__points-out">
                            <div>  </div>
                        </td>
                        <td className="sb-bordered-table-templ__point-balance">
                            <div> 4,583 Points </div>
                        </td>

                    </tr>

                </UiTable>
            </div>
        </>
    )
}